import {useState} from "react";
import {Button} from "react-bootstrap";
import {announce} from "./announce";
import {common} from "../i18n";

export function CopyButton({text, label = common.copy, icon = 'bi-clipboard', disabled}: { text: string, label?: string, icon?: string, disabled?: boolean }) {
    const [copied, setCopied] = useState(false);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            announce(common.copied);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // Clipboard refused (insecure context or permission): the text is still selectable.
            announce(common.copyFailed);
        }
    };
    return (
        <Button size="sm" variant="outline-secondary" onClick={copy} title={label} disabled={disabled}>
            <i className={`bi ${copied ? 'bi-check-lg' : icon}`} aria-hidden="true"></i>
            <span className="visually-hidden">{label}</span>
        </Button>
    );
}
